var _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorSpace = function SvgColorSpace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M11.825 1.487a7.5 7.5 0 1 0 2.933 2.67"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.141,
    cy: 6.723,
    r: 0.625,
    stroke: "#000",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.422,
    cy: 8.17,
    r: 0.625,
    stroke: "#000",
    strokeWidth: 0.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.578,
    cy: 2.61,
    r: 0.625,
    stroke: "#000",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M6.279 5.022a3.799 3.799 0 1 1-1.646 3.605"
  })));
};
export default SvgColorSpace;